<template>
  <div v-outside-click="hideToolbox" class="flow__contextmenu" :style="{ ...flowPosition }">
    <i class="icon-auto-mode flow__icon flow__icon-arrow" @click="autoLayout"></i>
    <i
      class="icon-arrow-right-thin flow__icon flow__icon-arrow"
      :class="{ 'flow__icon-arrow_active': selectArrow }"
      @click="newArrowClicked"
    ></i>
    <i
      class="flow__icon"
      :class="{
        'icon-eye-off-outline': !showVerticalLines,
        'icon-eye-outline': showVerticalLines,
      }"
      @click="toggleVerticalLines"
    ></i>
    <i class="flow__icon" :class="{ 'flow__icon-disable': selectedShapeType === undefined }" @click="toggleShapeType">
      <svg width="20" height="20">
        <g class="flow__icon-circle">
          <circle :cx="cx" :cy="cx" :r="radius" fill="transparent"></circle>
          <polyline :points="points" fill="transparent" />
        </g>
      </svg>
    </i>
  </div>
</template>

<script>
import { ShapeType } from "./Constants";
import { getAndPoints, getOrPoints, getXorPoints } from "../../../body/sidebar/flow/ElementUtils";
import DesignerMixin from "../../../DesignerMixin";
export default {
  mixins: [DesignerMixin],
  emits: ["hide-toolbox"],
  data() {
    return {
      selectArrow: false,
      cx: 10,
      cy: 10,
      radius: 8,
    };
  },
  computed: {
    showVerticalLines() {
      return this.$store.state.customFlow.showVerticalLines;
    },
    points() {
      switch (this.selectedShapeType) {
        case ShapeType.Or:
          return getOrPoints(this.cx, this.cy, this.radius);
        case ShapeType.And:
          return getAndPoints(this.cx, this.cy, this.radius);
        case ShapeType.Xor:
          return getXorPoints(this.cx, this.cy, this.radius);
        default:
          return "";
      }
    },
    selectedShapeType() {
      return this.$store.state.customFlow.shapeMap[this.$store.state.customFlow.selection.id]?.type;
    },
    flowPosition() {
      const flowContextMenu = this.$store.state.customFlow.flowContextMenu;
      return {
        left: flowContextMenu.x + "px",
        top: flowContextMenu.y + "px",
        transform: "translate(-100%, -150%)",
      };
    },
  },
  methods: {
    autoLayout() {
      this.$store.dispatch("customFlow/autoLayout");
    },
    newArrowClicked() {
      this.selectArrow = !this.selectArrow;
      if (this.selectArrow) this.$store.dispatch("customFlow/setNewArrowActive");
      else this.$store.dispatch("customFlow/resetArrowData");
    },
    toggleVerticalLines() {
      this.$store.dispatch("customFlow/toggleVerticalLines");
    },
    toggleShapeType() {
      if (this.selectedShapeType !== undefined) this.$store.dispatch("customFlow/setShapeType");
    },
    hideToolbox() {
      this.$emit("hide-toolbox");
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../../../assets/styles/variables";

.flow {
  &__contextmenu {
    width: 193px;
    position: fixed;
    padding: 0.5rem 1rem;
    gap: 1.5rem;
    z-index: 50;
    background-color: #f1f3f7;
    border-radius: @kk-border-radius;
    box-shadow: @kk-primary-box-shadow;
    display: flex;
  }
  &__icon {
    font-size: 1.5rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: @kk-color-primary-blue;
    &-arrow {
      &_active {
        pointer-events: auto;
        color: @kk-color-gold;
      }
    }
    &-circle {
      stroke: @kk-color-primary-blue;
      stroke-width: 1.5;
    }
    &-disable {
      color: @kk-color-gray-1;
      cursor: not-allowed;
    }
    &-disable &-circle {
      stroke: @kk-color-gray-1;
      cursor: not-allowed;
    }
  }
}
.dense {
  font-size: 1.3rem;
}
</style>
